import { useQuery } from "@tanstack/react-query";
import {
	getForecastReport,
	type GetForecastReportParams,
} from "../repositories/ForecastReportRepository";

type UseForecastReportParams = Omit<GetForecastReportParams, "signal">;

export const useForecastReport = ({
	startYear,
	endYear,
}: UseForecastReportParams) => {
	return useQuery({
		queryKey: ["forecast-report", startYear, endYear],
		queryFn: ({ signal }) => getForecastReport({ startYear, endYear, signal }),
		enabled:
			!!startYear &&
			!!endYear &&
			startYear <= endYear &&
			startYear > 1900 &&
			endYear < 2200,
		refetchOnWindowFocus: false,
		refetchOnReconnect: false,
	});
};
